import { Component, OnInit } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { CookieOverviewService } from '@client/app/modules/cookie-banner/components/cookie-overview/cookie-overview.service';

@Component({
    selector: 'cookie-overview',
    standalone: false,
    template: `
        <div id="cookie-overview">
            <div class="alert alert-warning font-size-1-3 font-weight-500 justify-content-center row" *ngIf="isDemo">
                {{ 'Consent results are sample data for demo purposes' | translate }}
            </div>
            <page-header
                [icon]="['SIDEMENUES', 'DATA_PRIVACY', 'CONSENT_OVERVIEW', 'COOKIE'] | monIcons"
                [header]="'Cookie Overview' | translate"
                [subHeader]="subHeaderText | translate">
            </page-header>
            <div class="row cookie-overview-panels">
                <div class="col-48 cookie-overview-wrapper">
                    <cookie-banner-cookie-overview
                        [domain]="domain"
                        [cookies]="cookies">
                    </cookie-banner-cookie-overview>
                </div>
            </div>
        </div>
    `,
})
export class CookieOverviewComponent implements OnInit {
    domain: any;
    isDemo: boolean = false;
    cookies: any;
    subHeaderText: string = 'Give an overview of the cookies used on your website. Finish a domain scan to display the automatically found cookies.';

    constructor (
        private sessionService: SessionService,
        private cookieOverviewService: CookieOverviewService,
    ) {}

    ngOnInit (): void {
        this.domain = this.sessionService.domain;
        this.isDemo = (this.cookieOverviewService as any).hasDemoAccess();
        this.getCookies();
    }

    getCookies (): void {
        this.cookieOverviewService.getCookies(this.domain.id).then((cookies: any) => {
            this.cookies = cookies;
        });
    }
}
